/*
 * Blog filter
 */

export const blogFilter = () => {
  // avoid WP conflict
  var $j = jQuery.noConflict()

  function ajaxData(data) {
    // console.log(
    //   'data.category: ' +
    //     data.category +
    //     '  |  data.pageNumber: ' +
    //     data.pageNumber,
    // )
    $j.ajax({
      type: 'POST',
      url: '/wp-admin/admin-ajax.php',
      dataType: 'html',
      data: {
        action: 'filter_blog',
        category: data.category,
        pageNumber: data.pageNumber,
      },
      success: function (res) {
        $j('.blog-results').html(res)
      },
    })
  }

  // filter object
  var filterObj = {
    category: '',
    pageNumber: 1,
  }

  function updateFilter() {
    filterObj.category = $j('#js-categories').val()
    filterObj.pageNumber = 1
  }

  // category change
  $j('#js-categories').change(function () {
    updateFilter()
    ajaxData(filterObj)
  })

  // pagination
  $j(document).on('click', '.blog-results .page-numbers', function () {
    event.preventDefault()
    var $number = 1
    if ($j(this).hasClass('current')) {
      return
    } else if ($j(this).hasClass('next')) {
      $number = filterObj.pageNumber + 1
    } else if ($j(this).hasClass('prev')) {
      $number = filterObj.pageNumber - 1
    } else {
      $number = parseInt($j(this).text())
    }
    filterObj.pageNumber = $number
    ajaxData(filterObj)
  })
}
